var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [(_vm.createFtcRadShipment == false) ? _c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSearch($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Hub")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-crosshairs' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.HubList,
      "name": "origin",
      "placeholder": "Select Hub",
      "label": "text",
      "track-by": "value",
      "id": "hub",
      "multiple": false,
      "scroll": true
    },
    on: {
      "select": _vm.selecthub
    },
    model: {
      value: (_vm.selectedHub),
      callback: function($$v) {
        _vm.selectedHub = $$v
      },
      expression: "selectedHub"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Cash Deposit ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cashDepositID),
      expression: "cashDepositID"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "cashDepositID",
      "id": "cashDepositID",
      "placeholder": "Enter Cash Deposit ID"
    },
    domProps: {
      "value": (_vm.cashDepositID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cashDepositID = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Deposit Slip Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depositSlipNumber),
      expression: "depositSlipNumber"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "depositSlipNumber",
      "id": "depositSlipNumber",
      "placeholder": "Enter Deposit Slip Number"
    },
    domProps: {
      "value": (_vm.depositSlipNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.depositSlipNumber = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Bank")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.banklist,
      "placeholder": "Select Bank",
      "id": "bank",
      "append-to-body": true,
      "name": "bankName"
    },
    on: {
      "select": _vm.selectBank
    },
    model: {
      value: (_vm.bankName),
      callback: function($$v) {
        _vm.bankName = $$v
      },
      expression: "bankName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.branchName),
      expression: "branchName"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "branchName",
      "id": "branchName",
      "placeholder": "Branch Name"
    },
    domProps: {
      "value": (_vm.branchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.branchName = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Account Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accountNumber),
      expression: "accountNumber"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "accountNumber",
      "id": "accountNumber",
      "placeholder": "Account Number"
    },
    domProps: {
      "value": (_vm.accountNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accountNumber = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Deposit From Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depositFromDate),
      expression: "depositFromDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "max": _vm.depositToDate,
      "name": "depositFromDate"
    },
    domProps: {
      "value": (_vm.depositFromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.depositFromDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Deposit To Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.depositToDate),
      expression: "depositToDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "min": _vm.depositFromDate,
      "name": "depositToDate"
    },
    domProps: {
      "value": (_vm.depositToDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.depositToDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Trip ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-tag' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripID),
      expression: "tripID"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "tripID",
      "id": "tripID",
      "placeholder": "Enter Trip ID"
    },
    domProps: {
      "value": (_vm.tripID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tripID = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Trip Close From Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripCloseFromDate),
      expression: "tripCloseFromDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "max": _vm.tripCloseToDate,
      "name": "tripCloseFromDate"
    },
    domProps: {
      "value": (_vm.tripCloseFromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tripCloseFromDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Trip Close To Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tripCloseToDate),
      expression: "tripCloseToDate"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "min": _vm.tripCloseFromDate,
      "name": "tripCloseToDate"
    },
    domProps: {
      "value": (_vm.tripCloseToDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tripCloseToDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "2rem"
    }
  }, [_c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                        "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])], 1)], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Settlement Report")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("Export Data")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "reportdetails"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', [_vm._v("Sr.No")]), _vm._v(" "), _c('th', [_vm._v("Hub")]), _vm._v(" "), _c('th', [_vm._v("Trip Id")]), _vm._v(" "), _c('th', [_vm._v("Trip End Date")]), _vm._v(" "), _c('th', [_vm._v("AWB")]), _vm._v(" "), _c('th', [_vm._v("Amount Collected (INR)")]), _vm._v(" "), _c('th', [_vm._v("Total Amount Deposited")]), _vm._v(" "), _c('th', [_vm._v("Deposit ID")]), _vm._v(" "), _c('th', [_vm._v("Settlement status")])])]), _vm._v(" "), _c('tbody', {
    attrs: {
      "id": "tbody"
    }
  }, [_vm._l((_vm.reportData), function(item, index) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.offset + index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedHub ? _vm.selectedHub.text : _vm.hubname) + "(" + _vm._s(item.hubid) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tmstripid ? item.tmstripid : "Consignee pickup"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tmstripid ? _vm.$options.filters.moment(item.tripenddate) : "NA"))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item.awb) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(item.ftccashpayment)))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(Number(item.ftccashpayment) - Number(item.ftcsettlementpendingamt)) + "\n                ")]), _vm._v(" "), _c('td', [(item.ftcdepositid) ? [_c('span', [_vm._v(_vm._s(item.ftcdepositid[0]))]), _vm._v(" "), (item.ftcdepositid && item.ftcdepositid.length > 1) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      attrs: {
        "title": "Click to open list of all deposit IDs"
      },
      on: {
        "click": function($event) {
          _vm.displayDeposit(item)
        }
      }
    }, [_vm._v("+" + _vm._s(item.ftcdepositid ? item.ftcdepositid.length - 1 : ''))]) : _vm._e()] : [_c('span', [_vm._v(" ")])]], 2), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item.ftcamountsettled == 1 ? "Settled" : "unsettled") + "\n                ")])])]
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1), _vm._v(" "), _c('div')], 1) : _vm._e(), _vm._v(" "), (_vm.createFtcRadShipment == true) ? _c('div', [_c('createFtcRadShipment', {
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "xl"
    },
    on: {
      "ok": function($event) {
        _vm.showDeposit = false
      }
    },
    model: {
      value: (_vm.showDeposit),
      callback: function($$v) {
        _vm.showDeposit = $$v
      },
      expression: "showDeposit"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("View deposit Id")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showDeposit = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', [_vm._v("AWB")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.3rem",
      "margin-bottom": "0.6rem"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.modalData.awb))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('label', [_vm._v("Deposit IDs")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.3rem",
      "margin-bottom": "0.6rem"
    }
  }), _vm._v(" "), _vm._l((_vm.modalData.ftcdepositid), function(item) {
    return _c('span', [_vm._v(" " + _vm._s(item) + " "), _c('br')])
  })], 2)])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1978e0a0","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/SettlementReport/SettlementReport.component.html
// module id = 1893
// module chunks = 3